import * as React from 'react';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common/on-stage';
import AnimateHeight from 'react-animate-height';
import uniqueId from '../../../common/uniqueId';
import { TPAComponentsConsumer } from '../../TPAComponentsConfig';
import { AccordionDataHooks, AccordionTheme, } from '../types';
import { classes, st } from './AccordionItem.st.css';
const ITEM_CONTENT_ID_PREFIX = '-item-content';
export class AccordionItem extends React.PureComponent {
    componentDidUpdate(previousProps) {
        if (this.props.id !== previousProps.id) {
            this.setState({
                itemContentId: `${this.props.id}` + uniqueId(ITEM_CONTENT_ID_PREFIX),
            });
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            itemContentId: `${this.props.id}` + uniqueId(ITEM_CONTENT_ID_PREFIX),
        };
    }
    render() {
        const { id, title, subtitle, className, 'data-hook': dataHook, isExpanded, suffix, size, children, disabled, headerRef, contentRef, theme, onClick, icons, titleTag, } = this.props;
        const ExpandIcon = icons?.collapsed ?? ChevronDown;
        const CollapseIcon = icons?.expanded ?? ChevronUp;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile, rtl }) => (React.createElement("div", { className: st(classes.root, { size, mobile, rtl, disabled, theme }, className), "data-hook": dataHook },
            React.createElement("button", { id: id, ref: headerRef, className: classes.itemButton, "data-hook": AccordionDataHooks.AccordionItemHeader, onClick: onClick, disabled: disabled, "aria-controls": this.state.itemContentId, "aria-expanded": isExpanded },
                React.createElement("div", { className: classes.headerWrapper },
                    React.createElement("div", { className: classes.header },
                        React.createElement("div", { className: classes.titleWrapper },
                            React.createElement(titleTag || 'h3', { className: classes.title, 'data-hook': 'title' }, title),
                            subtitle && (React.createElement("div", { className: classes.subtitle, "data-hook": "subtitle" }, subtitle))),
                        React.createElement("div", { className: classes.suffix }, suffix)),
                    React.createElement("div", { className: classes.iconButton, "aria-hidden": "true" }, isExpanded ? (React.createElement(CollapseIcon, { className: classes.arrow, "data-hook": "collapseIcon", "data-label": `Collapse-${CollapseIcon.displayName}` })) : (React.createElement(ExpandIcon, { className: classes.arrow, "data-hook": "expandIcon", "data-label": `Expand-${ExpandIcon.displayName}` }))))),
            React.createElement(AnimateHeight, { duration: 300, height: isExpanded ? 'auto' : 0, "aria-hidden": null, easing: "cubic-bezier(.39,.11,.37,.99)", animateOpacity: true },
                React.createElement("div", { ref: contentRef, id: this.state.itemContentId, "data-hook": AccordionDataHooks.AccordionItemContent, role: "region", "aria-labelledby": id, "aria-hidden": !isExpanded },
                    React.createElement("div", { className: classes.content }, children))),
            theme === AccordionTheme.Line && (React.createElement("div", { className: classes.divider }))))));
    }
}
//# sourceMappingURL=AccordionItem.js.map